import { LinkPreview } from "@shared/ui/LinkPreview";
import styles from "./YoutubeVideoCell.module.scss";

type YoutubeVideoCellProps = {
  videoUrl: string;
};

export function YoutubeVideoCell({ videoUrl }: YoutubeVideoCellProps) {
  return (
    <div className={styles.videoEmbed}>
      <LinkPreview url={videoUrl} youtubePreview="thumbnail" />
    </div>
  );
}
